/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

// Package Imports
import React, { ReactNode } from 'react';
import classNames from 'classnames';

// Component Imports
import Spinner from '@/components/spinner';

// Style Imports
import styles from './stylizedButton.module.scss';

interface StylizedButtonProps {
  children: ReactNode;
  submitType?: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'neutral'
    | 'cancel'
    | 'textonly'
    | 'link';
  size?: 'mini' | 'small' | 'medium' | 'large';
  disabled?: boolean;
  tabIndex?: string | number;
  ariaPressed?: boolean;
  ariaControls?: string;
  role?: string;
  loading?: boolean;
  handleClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  className?: string;
  [key: string]: any;
}

const StylizedButton: React.FC<StylizedButtonProps> = ({
  children,
  submitType = '',
  variant = 'primary',
  size = 'large',
  disabled = false,
  loading = false,
  handleClick,
  tabIndex = 0,
  ariaPressed = false,
  ariaControls = '',
  className,
  ...props
}) => {
  const classes = [styles.button, className];
  classes.push(styles[`${variant}`]);
  classes.push(styles[`${size}`]);
  if (loading) classes.push(styles.loading);

  return (
     
    <button
      type={submitType ? 'submit' : 'button'}
      onClick={handleClick}
      disabled={disabled}
      tabIndex={
        typeof tabIndex === 'string' ? parseInt(tabIndex, 10) : tabIndex
      }
      aria-controls={ariaControls}
      {...(props.role === 'button' ? { 'aria-pressed': ariaPressed } : {})}
      {...props}
      className={classNames(classes)}
    >
      {loading ? <Spinner /> : children}
    </button>
  );
};

export default StylizedButton;
